import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getBarangjasaEditContent = createAsyncThunk('/barangjasa_edit/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listGoodsServicesEdit/${id}`, {})
    return response.data;
})

export const barangjasaeditSlice = createSlice({
    name: 'barangjasa_edit',
    initialState: {
        isLoading: false,
        barangjasa_edit: []
    },

    /*extraReducers: {
        [getBarangjasaEditContent.pending]: state => {
            state.isLoading = true
        },
        [getBarangjasaEditContent.fulfilled]: (state, action) => {
            state.barangjasa_edit = action.payload.data
            state.isLoading = false
        },
        [getBarangjasaEditContent.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
          .addCase(getBarangjasaEditContent.pending, (state) => {
            state.isLoading = true;
          })
          .addCase(getBarangjasaEditContent.fulfilled, (state, action) => {
            state.barangjasa_edit = action.payload.data;
            state.isLoading = false;
          })
          .addCase(getBarangjasaEditContent.rejected, (state) => {
            state.isLoading = false;
          });
      }
})


export default barangjasaeditSlice.reducer